module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/47aef1d83301e37025553b8b6982e3dd.png";